// src/styles/colors.js

const colors = {
    gradient: {
      start: '#7B5FFF',  // More blue-purple for better distinction
      end: '#6B46C1',    // Deeper purple with better contrast
    },
  
    background: '#1A1625',      // Slightly darker for better contrast
    backgroundTwo: '#221D2E',   // Adjusted for better readability
    cardBackground: '#2D2640',  // Lighter card background for contrast
  
    primaryButton: '#6B46C1',   // WCAG AA compliant purple
    secondaryButton: '#8B5CF6', // Lighter purple with good contrast
    mutedButton: '#6D6D7E',     // Neutral gray for better visibility
    hoverHighlight: '#8B5CF6',  // Clear hover state
  
    textPrimary: '#FFFFFF',
    textSecondary: '#F3F4F6',   // Slightly warmer white
    textMuted: '#D1D5DB',       // Better contrast muted text
    whiteAlt: '#E5E7EB',
  
    destructive: '#EF4444',     // More accessible red
    success: '#10B981',         // Green for success states
    warning: '#F59E0B',         // Amber for warnings
    info: '#3B82F6',           // Blue for information
  
    // Accessibility colors
    focus: '#60A5FA',          // Clear blue focus indicator
    borderLight: '#374151',    // Visible borders
    borderDark: '#1F2937',
  
    purple1: '#7C3AED',
    purple2: '#4C1D95',
    purple3: '#5B21B6',
  
    primarySolid: '#ffffff',
  };
  
  export default colors;